export const checkIfObjectValuesAreEqual = (obj1, obj2) => {
  // sorting of keys must match, else this will not work
  return JSON.stringify(obj1) === JSON.stringify(obj2);
};

export const mapOptions = (values = [], prettifier = () => {}) => {
  return [
    ...values.map((value) => ({
      label: prettifier(value),
      value,
    })),
  ];
};

export const parseCSVFile = async (file, columns = []) => {
  const fileContent = await file.text();
  const rows = fileContent.split("\n");
  const errors = [];
  const rowErrors = [];
  const items = rows
    .filter((row, index) => {
      const r = row.replaceAll("\r", "").split(",");
      if (index === 0) {
        r.forEach((text, i) => {
          const columnText = columns[i]?.text;
          const isValid = text === columnText;
          if (!isValid) {
            errors.push(`Column ${i + 1} should be '${columnText}'`);
            rowErrors.push("header");
          }
        });
      }
      return index !== 0;
    })
    .map((row, index) => {
      const r = row.replaceAll("\r", "").split(",");
      const obj = {};
      r.forEach((text, i) => {
        obj[columns[i]?.key] = text;
      });
      const messages = [];
      r.forEach((text, i) => {
        if (columns[i]?.validation) {
          const errorStatus = columns[i]?.validation(text, obj);
          if (errorStatus.error) {
            messages.push(errorStatus.message);
          }
        }
      });
      if (messages.length) {
        errors.push(`Row ${index + 1}: ${messages.join(", ")}`);
        rowErrors.push(index + 1);
        obj.error = true;
      }
      return { ...obj, rowNumber: index + 1 };
    });
  return {
    items,
    passed: items.filter((item) => !item.error),
    errors,
    rowErrors,
  };
};

export const sortByKeyName = (key, string = true) => {
  return (a, b) => {
    if (a && b && a[key] && b[key]) {
      const first = string && a[key] ? a[key].toString().toLowerCase() : a[key];
      const second = string && b[key] ? b[key].toString().toLowerCase() : b[key];
      if (first < second) return -1;

      if (first > second) return 1;
    }

    return 0;
  };
};

export const excludeFilterAutoComplete = ({ isSelectedAll, value, allOptions, exclude }) => {
  // allOptions [{ label, value }, ...]
  // exclude [string, string]

  if ((!exclude || !allOptions) && (exclude?.length === 0 || allOptions?.length === 0)) {
    return {
      isSelectedAll,
      value,
    };
  }

  // if exclude is not empty the value should not to be empty before passing to api, it will get all items
  return {
    isSelectedAll: exclude?.length > 0 ? false : isSelectedAll,
    value:
      value?.length === 0
        ? allOptions.filter(({ value }) => !exclude?.includes(value))
        : value.filter((value) => !exclude?.includes(value)),
  };
};
